var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlobLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 947,
    viewBox: "0 0 443 947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-316.149 92.2406C-288.558 -59.38 -50.8311 -18.5882 125.431 43.0023C301.693 104.593 404.748 231.865 434.596 424.818C464.444 617.771 410.604 762.793 273.075 859.884C135.546 956.975 -28.9708 972.847 -220.476 907.5C-411.982 842.153 -505.335 713.543 -500.535 521.672C-495.735 329.8 -517.913 529.496 -316.149 92.2406Z",
    fill: "url(#paint0_radial_843_757)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_843_757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-22.5404 488.07) rotate(-15.1375) scale(2411.96 2949.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#7B00FF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#9D00FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5742C0",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3F27B7",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobLeft);
export default __webpack_public_path__ + "static/media/Blob-left.4160e1bbf8cf673eab4e7b2c187913a6.svg";
export { ForwardRef as ReactComponent };